import { IZone as Zone } from '../../models/zone';
import { MultiResponseType } from '../../models/multiResponseType';

export enum ActionType {
    FETCH_ZONES = 'FETCH_ZONES',
    FETCH_ZONES_SUCCESS = 'FETCH_ZONES_SUCCESS',
    FETCH_ZONES_FAIL = 'FETCH_ZONES_FAIL',
}

export interface IFetchZones {
    type: ActionType.FETCH_ZONES;
}
export interface IFetchZonesSuccess {
    type: ActionType.FETCH_ZONES_SUCCESS;
    payload: MultiResponseType<Zone>;
}
export interface IFetchZonesFail {
    type: ActionType.FETCH_ZONES_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchZones
    | IFetchZonesSuccess
    | IFetchZonesFail

